import styled from "@emotion/styled";
import AutorenewIcon from "@material-ui/icons/Autorenew";

const Container = styled("div")`
  display: flex;
  height: calc(100vh - 202px);
  justify-content: center;
  align-items: center;
`;

const RotatingAutorenewIcon = styled(AutorenewIcon)`
  & {
    width: 50px !important;
    height: 50px !important;
    animation: spin 4s linear infinite;
  }
  @-moz-keyframes spin {
    100% {
      -moz-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

export const Loader = () => {
  return (
    <Container>
      <RotatingAutorenewIcon />
    </Container>
  );
};
